module.exports = __webpack_public_path__ + "static/wash-sale-graphic-desktop.411bc465.svg";